import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { membershipsApi } from '../api/membershipsApi'
import type { MembershipDraft, MembershipPlan } from '../model/membership'

type State = { plans: MembershipPlan[]; loading: boolean; error: string | null }
const initialState: State = { plans: [], loading: false, error: null }

export const loadMembershipPlans = createAsyncThunk('memberships/plans', (status?: string) => membershipsApi.listPlans(status))
export const saveMembershipPlan = createAsyncThunk('memberships/savePlan', async (input: { id?: number; draft: MembershipDraft }) => input.id ? membershipsApi.updatePlan(input.id, input.draft) : membershipsApi.createPlan(input.draft))

const slice = createSlice({
  name: 'memberships', initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadMembershipPlans.pending, state => { state.loading = true; state.error = null })
      .addCase(loadMembershipPlans.fulfilled, (state, action) => { state.loading = false; state.plans = action.payload })
      .addCase(saveMembershipPlan.fulfilled, (state, action) => { state.loading = false; const index = state.plans.findIndex(item => item.id === action.payload.id); if (index >= 0) state.plans[index] = action.payload; else state.plans.unshift(action.payload) })
      .addMatcher(action => action.type.startsWith('memberships/') && action.type.endsWith('/pending'), state => { state.loading = true; state.error = null })
      .addMatcher(action => action.type.startsWith('memberships/') && action.type.endsWith('/rejected'), (state, action: { error: { message?: string } }) => { state.loading = false; state.error = action.error.message || 'Không thể tải dữ liệu membership.' })
  },
})
export const membershipsReducer = slice.reducer
